import { useState } from 'react';
import type { Screen } from './types';
import { useTweaks } from './hooks/useTweaks';
import { AppLayout } from './components/layout/AppLayout';
import { SourcesScreen } from './components/screens/SourcesScreen';
import { StreamScreen } from './components/screens/StreamScreen';
import { AskScreen } from './components/screens/AskScreen';
import { Theme90sMarquee } from './components/theme90s/Theme90sMarquee';
import { Theme90sFooter } from './components/theme90s/Theme90sFooter';
import { Theme90sToggle } from './components/theme90s/Theme90sToggle';
import { TweaksPanel } from './components/TweaksPanel';

export function App() {
  const [screen, setScreen] = useState<Screen>('sources');
  const { tweaks, setTweak, toggleTheme } = useTweaks();

  const is90s = tweaks.theme === '90s';

  const handleNav = (s: string) => {
    if (s === 'sources' || s === 'stream' || s === 'ask') {
      setScreen(s as Screen);
    }
  };

  let screenEl: React.ReactNode;
  switch (screen) {
    case 'sources': screenEl = <SourcesScreen onNav={handleNav} />; break;
    case 'stream':  screenEl = <StreamScreen  onNav={handleNav} />; break;
    case 'ask':     screenEl = <AskScreen />; break;
    default:        screenEl = <SourcesScreen onNav={handleNav} />;
  }

  return (
    <>
      {is90s && <Theme90sMarquee />}

      <AppLayout
        screen={screen}
        onNav={handleNav}
        previewMode={tweaks.previewMode}
        onTogglePreview={() => setTweak('previewMode', !tweaks.previewMode)}
      >
        {screenEl}
      </AppLayout>

      <Theme90sToggle on={is90s} onToggle={toggleTheme} />

      <TweaksPanel tweaks={tweaks} onSet={setTweak} />

      {is90s && <Theme90sFooter />}
    </>
  );
}
